export const letterSpacing = `
  letter-spacing: -0.01em
`;

export default letterSpacing;
